import {
  AdminOrganizationListItem,
  AdminOrganizationInstructor,
  AdminOrganizationsList,
  CreateOrganizationPayload,
  UpdateOrganizationPayload,
  AdminOrganizationResponse,
} from 'types/admin/organizations';
import { AxiosInstance, AxiosResponse } from 'axios';

import { Result } from 'services/Result';

interface ApiResponse<T> {
  data: T;
  isError: boolean;
}
export class OrganisationsEditorService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getOrganizations = async () => {
    const response = await this.axiosInstance.get<Result<AdminOrganizationsList>>(`/api/admin/organisations/`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching organizations.');
  };

  getOrganization = async (id: string) => {
    const response = await this.axiosInstance.get<Result<AdminOrganizationListItem>>(`/api/admin/organisations/${id}`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching organization.');
  };

  instructorsEmailLookup = async (emails: string[]) => {
    const response = await this.axiosInstance.post<string[], AxiosResponse<ApiResponse<AdminOrganizationInstructor[]>>>(
      `/api/admin/organisations/emailslookup`,
      { Emails: emails }
    );
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while inviting instructors.');
  };

  deleteOrganization = async (id: string) => {
    const response = await this.axiosInstance.delete(`/api/admin/organisations/${id}`);

    if (response.status !== 200 || response.data !== '') throw Error('There was an internal error while deleting the organization.');
  };

  saveNewOrganization = async (organization: CreateOrganizationPayload) => {
    const response = await this.axiosInstance.post<AdminOrganizationListItem, AxiosResponse<ApiResponse<AdminOrganizationResponse>>>(
      `/api/admin/organisations`,
      { ...organization }
    );

    if (response.status === 200 || response.status === 201) {
      return response.data.data;
    }
    throw Error('There was an internal error while saving the organisation.');
  };

  saveEditedOrganization = async (organization: UpdateOrganizationPayload) => {
    const response = await this.axiosInstance.put<AdminOrganizationListItem, AxiosResponse<ApiResponse<AdminOrganizationResponse>>>(
      `/api/admin/organisations`,
      { ...organization }
    );
    if (response.status === 200 || response.status === 201) {
      return null;
    }
    throw Error('There was an internal error while saving the organisation.');
  };
}

export default OrganisationsEditorService;
